import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Button from '../../Button/Button/index';

import './styles.scss';

function LogoutWarning(props = {}) {
  const { onLogoutFalse, onLogoutTrue } = props;
  return (
    <div className="logoutmodal">
      <div className="logoutmodal__container">
        <div className="logoutmodal__header">
          <h3>Logout?</h3>
          <button
            onClick={onLogoutFalse}
            type="button"
            className="btn logoutmodal__close"
          >
            <FontAwesomeIcon
              className="logoutmodal__close--icon"
              icon={faTimes}
            />
          </button>
        </div>
        <div className="logoutmodal__body">
          <p>
            If you logout, you will need to sign in again to access your
            account.
          </p>
          <div className="logoutmodal__buttons">
            <Button classname="solid" onClickHandler={onLogoutTrue}>
              Okay
            </Button>
            <Button classname="solid" onClickHandler={onLogoutFalse}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

LogoutWarning.propTypes = {
  onLogoutFalse: PropTypes.func.isRequired,
  onLogoutTrue: PropTypes.func.isRequired
};
LogoutWarning.defaultProps = {};

export default LogoutWarning;
